import ReactModal from 'react-modal'

export const DuplicateWarningModal = ({ isOpen, setIsOpen, setAccepted, address }) => {
    if (!address || !address.Duplication_Status) return null
    const [startMatchText, endMatchText] = address.Duplication_Status.split(address.Matching_Value)
    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            className="card bulk-allocate"
            contentLabel="Duplicate UPRN/VOA Warning Modal"
            key={address.Core_SPID}
            style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <h3>Warning</h3>
                <p>{startMatchText}<span style={{ color: address.Font_Colour }}>{address.Matching_Value}</span>{endMatchText}:</p>
                <ul>
                    {address.Duplicate_SPIDs.map(spid => {
                        return (
                            <li>{spid.Core_SPID}</li>
                        )
                    })}
                </ul>
                <p>Are you sure you wish to continue?</p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5em', width: '20em', alignSelf: 'center' }}>
                    <button className="button compact smaller-text cancel" onClick={() => setIsOpen(false)}>No</button>
                    <button className="button compact smaller-text background-primary colour-white" onClick={() => {
                        setAccepted(true)
                        setIsOpen(false)
                    }}
                    >
                        Yes
                    </button>
                </div>
            </div>
        </ReactModal>
    )
}